import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

export function CustomTabPanel(props) {
  const { children, value, index, sx, ...other } = props;
  const isActive = value === index;
  
  return (
    <Box
      role="tabpanel"
      hidden={!isActive}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={{
        pt: 1,
        ...sx,
        display: isActive ? "flex" : "none",
        flexDirection: "column",
        flex: isActive ? 1 : 0,
        minHeight: 0,
        height: "100%",
      }}
      {...other}
    >
      {isActive && children}
    </Box>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
